import {Button, Col, DatePicker, Form, FormListFieldData, Input, InputNumber, Row, Select} from "antd";
import dayjs from "dayjs";
import {DeleteOutlined, PlusOutlined} from "@ant-design/icons";
import React from "react";
import {IDesignation} from "../types/experience.types";


interface IPreviousExperienceProps {
    form: any;
    designations: IDesignation[];
}

const PreviousExperience = (props: IPreviousExperienceProps) => {

    function setDesignationCode(name: number, value: string) {
        const selected = props.designations.find((d: IDesignation) => d.id === value);
        props.form.setFieldValue(["previous", name, "designationCode"], selected?.code);
    }

    return (
        <section className="pn__employee-create__form__fixed-width previous-experience">
            <Form.List name="previous">
                {(fields: FormListFieldData[], {add, remove}) => (
                    <>
                        {fields.map(({key, name, ...restField}) => (
                            <Col key={key} span={20}>
                                <Form.Item
                                    {...restField}
                                    label="Company Name"
                                    name={[name, "companyName"]}
                                    className="formInputFields"
                                >
                                    <Input placeholder="Enter company name"/>
                                </Form.Item>

                                <Form.Item
                                    {...restField}
                                    label="Designation"
                                    name={[name, "designationId"]}
                                    className="formInputFields"
                                >
                                    <Select
                                        virtual={false}
                                        placeholder="Select designation"
                                        onChange={(value) => setDesignationCode(name, value)}
                                    >
                                        {props.designations.map((designation: IDesignation) => (
                                            <Select.Option
                                                key={designation.id}
                                                value={designation.id}
                                            >
                                                {designation.displayName}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>

                                <Form.Item
                                    {...restField}
                                    name={[name, "designationCode"]}
                                    hidden={true}
                                >
                                    <Input/>
                                </Form.Item>

                                <Row gutter={10}>
                                    <Col span={12}>
                                        <Form.Item
                                            {...restField}
                                            label="Job Duration (Years)"
                                            name={[name, "years"]}
                                            className="formInputFields"
                                        >
                                            <InputNumber style={{width: "100%"}} placeholder="Years"/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            {...restField}
                                            label="Job Duration (Months)"
                                            name={[name, "months"]}
                                            className="formInputFields"
                                        >
                                            <InputNumber style={{width: "100%"}} placeholder="Months"/>
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <Form.Item
                                    {...restField}
                                    label="CTC (per annum)"
                                    name={[name, "annualCTC"]}
                                    className="formInputFields"
                                >
                                    <InputNumber style={{width: "100%"}} placeholder="Enter CTC"/>
                                </Form.Item>

                                <Row gutter={10}>
                                    <Col span={12}>
                                        <Form.Item
                                            {...restField}
                                            label="Start Date"
                                            name={[name, "startDate"]}
                                            className="formInputFields"
                                        >
                                            <DatePicker
                                                placeholder="Select date"
                                                style={{width: "100%"}}
                                                format="YYYY-MM-DD"
                                                disabledDate={(current) => current && current.isAfter(dayjs())}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            {...restField}
                                            label="End Date"
                                            name={[name, "endDate"]}
                                            className="formInputFields"
                                        >
                                            <DatePicker
                                                placeholder="Select Date"
                                                style={{width: "100%"}}
                                                format="YYYY-MM-DD"
                                                disabledDate={(current) => current && current.isAfter(dayjs())}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <Form.Item
                                    {...restField}
                                    label="Reason for Leaving"
                                    name={[name, "reasonForLeaving"]}
                                    className="formInputFields"
                                >
                                    <Input.TextArea placeholder="Enter Reason for Leaving"/>
                                </Form.Item>

                                <div>
                                    {/*<Button onClick={handleResetFields}>Reset</Button>*/}
                                    {fields.length > 1 && (
                                        <Button
                                            danger
                                            onClick={() => remove(name)}
                                            className="remove-button"
                                            icon={<DeleteOutlined/>}
                                        >
                                            Remove
                                        </Button>
                                    )}
                                </div>
                            </Col>
                        ))}

                        <div className={"employee-create__actions add-btn"}>
                            <Button
                                type="primary"
                                shape={'round'}
                                icon={<PlusOutlined/>}
                                onClick={() => add()}
                            >
                                Add New Experience
                            </Button>
                        </div>
                    </>
                )}
            </Form.List>
        </section>
    )
}

export default PreviousExperience;
